module.exports = __webpack_public_path__ + "img/kinderplus_ninatarea.188bde42.webp";